import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import TopNavBar from './TopNavBar';
import PlatformSidebar from './PlatformSidebar';

/** Shell for the Platform Admin experience: fixed top bar + sidebar. */
export default function DashboardLayout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-brand-bg">
      <TopNavBar onMenuClick={() => setNavOpen(true)} showUtilityIcons={false} showOrgPicker={false} />
      <PlatformSidebar open={navOpen} onClose={() => setNavOpen(false)} />
      {/* The top bar + sidebar are position:fixed; the page scrolls normally (single scrollbar). */}
      <main className="mt-16 p-4 sm:p-6 lg:ml-[280px]">
        <Outlet />
      </main>
    </div>
  );
}
